/* eslint-disable react/jsx-filename-extension */
import React from "react";
import ReactDOM from "react-dom";

import "whatwg-fetch";
import LayoutMedicineThemeProvider from "./src/layouts/LayoutMedicineThemeProvider";
import LayoutMainThemeProvider from "./src/layouts/LayoutMainThemeProvider";
import {arenzaStorage} from "./src/core/storage";

export const replaceHydrateFunction = () => {
  return (element, container) => {
    const root = ReactDOM.createRoot(container)
    root.render(element)
  }
}

export function wrapRootElement({ element }) {
  if (!arenzaStorage.session('utmTagsInUrl')) {
    arenzaStorage.session('utmTagsInUrl', window.location.href);
  }

  return element;
}

export function wrapPageElement({ element, props }) {
  if (props.uri.includes("lizing-meditsinskogo-oborudovaniya")) {
    return <LayoutMedicineThemeProvider {...props}>{element}</LayoutMedicineThemeProvider>;
  }

  return <LayoutMainThemeProvider {...props}>{element}</LayoutMainThemeProvider>;
}
